<div class="tw-flex tw-flex-col tw-gap-2">
    <mat-progress-bar
        mode="indeterminate"
        [appVisible]="loadingReport"
    ></mat-progress-bar>

    <div
        *ngIf="requestFailed"
        class="tw-bg-m3ErrorContainer tw-text-m3OnErrorContainer tw-p-4 tw-box-border tw-rounded-m3sm tw-text-center"
    >
        Request Failed
    </div>

    <mat-card>
        <mat-card-content class="tw-flex tw-flex-col">
            <div class="tw-flex tw-justify-between">
                <form [formGroup]="dateForm">
                    <mat-form-field appearance="fill">
                        <mat-label>Select Week</mat-label>

                        <input
                            matInput
                            formControlName="date"
                            [matDatepicker]="picker"
                            (dateChange)="dateChange($event)"
                        />
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </form>

                <div
                    class="tw-flex tw-flex-row tw-gap-2 tw-items-center tw-ml-auto"
                >
                    <button
                        mat-raised-button
                        matTooltip="Export Report"
                        (click)="exportReport()"
                    >
                        Export
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-content class="tw-overflow-hidden">
            <table
                mat-table
                [dataSource]="dataSource"
                class="tw-w-full tw-bg-transparent"
                matSort
                (matSortChange)="sortChange($event)"
            >
                <ng-container matColumnDef="FirstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        First Name
                    </th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.firstName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="LastName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Last Name
                    </th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.lastName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="DayofWeek">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Day of Week
                    </th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.dayOfWeek }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Week">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Week
                    </th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.week }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Year">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Year
                    </th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.year }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Hours">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Hours
                    </th>
                    <td mat-cell *matCellDef="let report">
                        {{ report.hours }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Notes">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Notes
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let report"
                        class="tw-max-w-[170px] tw-whitespace-normal tw-break-words tw-p-4"
                    >
                        {{ report.notes }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                ></tr>
            </table>
        </mat-card-content>
        <mat-card-actions class="tw-flex tw-justify-end">
            <mat-paginator
                class="tw-bg-transparent"
                [pageIndex]="pageIndex"
                (page)="changePage($event)"
                [pageSize]="page.countRequested"
                [length]="page.totalCount"
                [hidePageSize]="true"
            ></mat-paginator>
        </mat-card-actions>
    </mat-card>
</div>
